import { Address, RequireOnly } from '@pelicargo/types';
import { FreightService, Request } from '@prisma/client';
import { useMemo } from 'react';

export type RequestPickupInput = RequireOnly<Request, 'freight_services' | 'cargo_origin'>;

// EXW pickups are only ever shown as the origin zip code — never the full street address (PEL-3036).
export const getRequestPickupOrigin = (request?: RequestPickupInput) => {
  if (!request?.freight_services?.includes(FreightService.EXW)) return undefined;
  const cargoOrigin = request.cargo_origin as Address | null | undefined;
  return cargoOrigin?.zip_code || undefined;
};

export const useRequestPickupOrigin = (request?: RequestPickupInput) =>
  useMemo(() => getRequestPickupOrigin(request), [request]);
